import React from 'react';
import className from 'classnames';
import { connect } from 'react-redux';

class Header extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    componentDidMount() {
    }

    render() {
        const { language, ...props } = this.props;

        return (
            <div className="table-header-container">
                <div className="title">
                    {language[props.title]}
                </div>
                {props.filterEnabled && <div className="filter-col">
                    {/* TO DO */}
                </div>}
            </div>
        )
    }
}

Header.defaultProps = {
    title: 'table_title',
    filterEnabled: true
}

export default connect(
    state => ({
        language: state.app.language
    })
)(Header)